import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Measurement_Uncertainty_Report_Table = ({ setEdit }) => {
  const data = [
    {
      srNo: "01",
      parameter: "VM",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "02",
      parameter: "ASH",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "01",
      parameter: "VM",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "02",
      parameter: "ASH",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "01",
      parameter: "VM",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "02",
      parameter: "ASH",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "01",
      parameter: "VM",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "02",
      parameter: "ASH",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "01",
      parameter: "VM",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
    {
      srNo: "02",
      parameter: "ASH",
      measurementPeriod: 3.09,
      observationValue: 3.09,
      standardDeviation: 2.09,
      standardUncertainty: 0.1,
      typeBUncertainty: 0.1,
      combinedUncertainty: 23.8,
      date: "1 JAN 2025",
      time: "1.23 PM",
      action: "👁️",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>
                <th>Sr. No.</th>
                <th>Parameter</th>
                <th>Measurement Period</th>
                <th>Observation Value</th>
                <th>Standard Deviation</th>
                <th>Standard Uncertainty</th>
                <th>Type B Uncertainty</th>
                <th>Combined Uncertainty</th>
                <th>Date & Time</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.srNo}</td>
                  <td>{row.parameter}</td>
                  <td>{row.measurementPeriod}</td>
                  <td>{row.observationValue}</td>
                  <td>{row.standardDeviation}</td>
                  <td>{row.standardUncertainty}</td>
                  <td>{row.typeBUncertainty}</td>
                  <td>{row.combinedUncertainty}</td>
                  <td>{`${row.date} | ${row.time}`}</td>
                  <td>
                    <div
                      className="edit_icon_holder"
                      onClick={() => {
                        setEdit(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faEye} className="edit_icon" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Measurement_Uncertainty_Report_Table;
